const BookingReportPage = () => {
  return (
    <div>
      <h1>Booking Report</h1>
    </div>
  );
};

export default BookingReportPage;
